import { apiFetch } from './fetch';

export type StorageSummaryDto = {
  usedBytes: number;
  planLimitBytes: number;
  addOnBytes: number;
  totalLimitBytes: number;
  usagePercent: number;
  totalDocuments: number;
  expiringWithin7Days: number;
};

export type StorageDocumentDto = {
  id: string;
  name: string;
  fileSizeBytes: number;
  createdAt: string;
  expiresAt: string | null;
  isArchived: boolean;
};

export async function fetchStorageSummary(): Promise<StorageSummaryDto> {
  const res = await apiFetch('/api/storage/summary');
  if (!res.ok) {
    throw new Error(`Failed to fetch storage summary (${res.status})`);
  }
  return (await res.json()) as StorageSummaryDto;
}

export async function fetchStorageDocuments(
  page = 1,
  pageSize = 50,
): Promise<StorageDocumentDto[]> {
  const res = await apiFetch(`/api/storage/documents?page=${page}&pageSize=${pageSize}`);
  if (!res.ok) {
    throw new Error(`Failed to fetch storage documents (${res.status})`);
  }
  const data = (await res.json()) as StorageDocumentDto[] | { items?: StorageDocumentDto[]; Items?: StorageDocumentDto[] };
  if (Array.isArray(data)) return data;
  return data.items ?? data.Items ?? [];
}
